<div class="card-body">
    <div id="apex-basic-line-chart"></div>
</div>